module.exports = __webpack_public_path__ + "img/museum.be5030ca.webp";